import Empty from '@/views/Empty';
import Dashboard from '@/views/pages/dashboard/Index';

export default {
  path: 'dashboard',
  component: Empty,
  meta: {},
  children: [
    {
      path: '',
      name: 'Dashboard',
      component: Dashboard,
    },
  ],
};



// WEBPACK FOOTER //
// ./src/router/dashboard.js